var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _dec33, _dec34, _dec35, _dec36, _dec37, _dec38, _dec39, _dec40, _dec41, _dec42, _dec43, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { Component, Prop, CustomElement, Event, State, Interceptor, html, classMap, nothing, Watch } from '@sick-davinci/ce-decorators';
import { style } from './TextField.style';
/**
 * A `davinci-text-field` can be used to enter or edit a single line of text. It's used to enter email addresses and passwords as well.
 *
 * @example
 * ```html
 * <davinci-text-field
 *     label="Email"
 *     placeholder="enter a valid email"
 *     value=""
 *     required
 *     pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$">
 * </davinci-text-field>
 * ```
 */

export let TextField = (_dec = Component({
  tag: 'davinci-text-field',
  style: [style]
}), _dec2 = Prop(), _dec3 = Reflect.metadata("design:type", String), _dec4 = Prop({
  type: String
}), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec8 = Prop(), _dec9 = Reflect.metadata("design:type", String), _dec10 = Prop(), _dec11 = Reflect.metadata("design:type", Boolean), _dec12 = Prop(), _dec13 = Reflect.metadata("design:type", Boolean), _dec14 = Prop(), _dec15 = Reflect.metadata("design:type", Boolean), _dec16 = Prop(), _dec17 = Reflect.metadata("design:type", Boolean), _dec18 = Prop(), _dec19 = Reflect.metadata("design:type", Boolean), _dec20 = Prop(), _dec21 = Reflect.metadata("design:type", Boolean), _dec22 = Prop({
  type: String
}), _dec23 = Reflect.metadata("design:type", Object), _dec24 = Prop({
  reflectAsAttribute: false
}), _dec25 = Reflect.metadata("design:type", String), _dec26 = State(), _dec27 = Reflect.metadata("design:type", Boolean), _dec28 = State(), _dec29 = Reflect.metadata("design:type", Boolean), _dec30 = Event(), _dec31 = Reflect.metadata("design:type", Object), _dec32 = Event(), _dec33 = Reflect.metadata("design:type", Object), _dec34 = Event('pattern-match-change'), _dec35 = Reflect.metadata("design:type", Object), _dec36 = Interceptor('pattern'), _dec37 = Reflect.metadata("design:paramtypes", [String, Object]), _dec38 = Watch('validator'), _dec39 = Reflect.metadata("design:paramtypes", [String, String]), _dec40 = Watch('pattern'), _dec41 = Reflect.metadata("design:paramtypes", [Object, Object]), _dec42 = Interceptor('type'), _dec43 = Reflect.metadata("design:paramtypes", [String, String]), _dec(_class = (_class2 = class TextField extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "name", _descriptor, this);

    _initializerDefineProperty(this, "type", _descriptor2, this);

    _initializerDefineProperty(this, "label", _descriptor3, this);

    _initializerDefineProperty(this, "placeholder", _descriptor4, this);

    _initializerDefineProperty(this, "required", _descriptor5, this);

    _initializerDefineProperty(this, "disabled", _descriptor6, this);

    _initializerDefineProperty(this, "error", _descriptor7, this);

    _initializerDefineProperty(this, "warning", _descriptor8, this);

    _initializerDefineProperty(this, "readonly", _descriptor9, this);

    _initializerDefineProperty(this, "ignorePattern", _descriptor10, this);

    _initializerDefineProperty(this, "pattern", _descriptor11, this);

    _defineProperty(this, "_valueUntilFirstRender", '');

    _initializerDefineProperty(this, "notEmpty", _descriptor12, this);

    _initializerDefineProperty(this, "isSelected", _descriptor13, this);

    _initializerDefineProperty(this, "change", _descriptor14, this);

    _initializerDefineProperty(this, "input", _descriptor15, this);

    _initializerDefineProperty(this, "patternMatchChange", _descriptor16, this);

    _defineProperty(this, "lastPatternTestResult", true);

    _defineProperty(this, "blurTrap", () => {
      this.isSelected = false;
      this.shadowRoot.querySelector('.inputwrapper').classList.remove('focus-within');
    });

    _defineProperty(this, "focusTrap", () => {
      this.isSelected = true;
      this.shadowRoot.querySelector('.inputwrapper').classList.add('focus-within');
    });

    _defineProperty(this, "changeTrap", event => {
      event.preventDefault();
      event.stopPropagation(); // Only if the current value matches the pattern a change-event is emitted.
      // Further checks are not necessary because the browser has already determined that a change-event should be fired.

      if (this.lastPatternTestResult) {
        this.change.emit(this.value);
      }
    });

    _defineProperty(this, "inputTrap", event => {
      event.preventDefault();
      event.stopPropagation();

      this._onValueUpdated();

      this.input.emit(this.value);
    });
  }

  _getInputElement() {
    var _this$shadowRoot;

    return (_this$shadowRoot = this.shadowRoot) === null || _this$shadowRoot === void 0 ? void 0 : _this$shadowRoot.querySelector('input');
  }

  _getInputElementValue() {
    var _this$_getInputElemen;

    return (_this$_getInputElemen = this._getInputElement()) === null || _this$_getInputElemen === void 0 ? void 0 : _this$_getInputElemen.value;
  }

  _setInputElementValue(value) {
    const inputElement = this._getInputElement();

    if (inputElement) {
      inputElement.value = value;

      this._onValueUpdated();
    }
  }

  /**
   * Current value of a text field.
   */
  set value(val) {
    val = typeof val === 'number' ? val.toString() : val; // DAVIBE-403: allow numeric values

    if (!val) {
      val = '';
    } // remember value in case input-element is not rendered yet


    this._valueUntilFirstRender = val;

    this._setInputElementValue(val);
  }

  get value() {
    var _this$_getInputElemen2;

    // return initial value in case input-element is not rendered yet
    return (_this$_getInputElemen2 = this._getInputElementValue()) !== null && _this$_getInputElemen2 !== void 0 ? _this$_getInputElemen2 : this._valueUntilFirstRender;
  }

  /**
   * Allow users to focus text fields
   * @example
   * ```javascript
   * document.querySelector('davinci-text-field').focus();
   * ```
   */
  focus() {
    const inputElm = this.shadowRoot.querySelector('input');

    if (inputElm) {
      inputElm.focus();
    }
  }

  componentFirstRender() {
    super.componentFirstRender();

    this._setInputElementValue(this._valueUntilFirstRender);
  }

  render() {
    // Do not show the placeholder for date-related types.
    const isDateType = this.type === 'datetime-local' || this.type === 'time' || this.type === 'date';
    return html`
      <div class="inputwrapper ${classMap({
      notempty: this.value !== '' || this.notEmpty || isDateType,
      selected: this.isSelected
    })}">
      <label for="input-field" class="label">${this.label}${this.required ? html` *` : nothing}</label>
        <div class="${classMap({
      input: true
    })}">
          <label class="placeholder">${this.placeholder}</label>
          <input
            @blur="${this.blurTrap}"
            @focus="${this.focusTrap}"
            @change="${this.changeTrap}"
            @input="${this.inputTrap}"
            id="input-field"
            type="${this.type}"
            ?disabled="${this.disabled}"
            ?readonly="${this.readonly}"
            ?error="${this.error}"
            ?warning="${this.warning}"
            title="${this.type !== 'password' ? this.value : ''}"
          />
        </div>
        <slot></slot>
      </div>
    `;
  }

  interceptPattern(_oldValue, newValue) {
    if (typeof newValue === 'string') {
      return new RegExp(newValue);
    }

    if (!(newValue instanceof RegExp)) {
      return null;
    }

    return newValue;
  }

  onValidatorChange(_oldValue, _newValue) {
    this._testPattern();
  }

  onPatternChange(_oldValue, _newValue) {
    this._testPattern();
  }

  interceptType(_oldValue, newValue) {
    if (!['text', 'password', 'date', 'number', 'datetime-local', 'time'].includes(newValue)) {
      return 'text';
    }

    return newValue;
  }

  // Properties like the notEmpty-state or the pattern-matching-result must be recomputed when the value of the input-element is updated.
  _onValueUpdated() {
    // The input-element's value is the the single source of truth.
    const value = this.value;
    this.notEmpty = value.length > 0;

    this._testPattern();
  }
  /**
   * Tests the current value against this text-field's {@link pattern}
   * and updates the {@link error}-property accordingly.
   *
   * This function should be called anytime the {@link value} or the {@link pattern} changes.
   *
   * @returns true if the value matches this text-field's {@link pattern}
   * @private
   */


  _testPattern() {
    const previousPatternTestResult = this.lastPatternTestResult;

    if (this.ignorePattern === false && this.pattern) {
      this.lastPatternTestResult = this.pattern.test(this.value);
    } else {
      this.lastPatternTestResult = true; // if no pattern the "lastTestResult" is true because no pattern always matches thus triggering pattern change event
    }

    if (previousPatternTestResult !== this.lastPatternTestResult) {
      window.setTimeout(() => {
        // [DAVIBE-550] Updating the error-property must also be deferred because the ce-decorators
        // do not support calling property-setters from other property-setters.
        this.error = !this.lastPatternTestResult;
        this.emitPatternMatch();
      }, 0);
    }

    return this.lastPatternTestResult;
  }

  emitPatternMatch() {
    if (this.pattern) {
      this.patternMatchChange.emit(this.lastPatternTestResult);
    }
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "type", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 'text';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "placeholder", [_dec8, _dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "required", [_dec10, _dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec12, _dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "error", [_dec14, _dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "warning", [_dec16, _dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "readonly", [_dec18, _dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "ignorePattern", [_dec20, _dec21], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "pattern", [_dec22, _dec23], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec24, _dec25], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "notEmpty", [_dec26, _dec27], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "isSelected", [_dec28, _dec29], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec30, _dec31], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec32, _dec33], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "patternMatchChange", [_dec34, _dec35], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class2.prototype, "interceptPattern", [_dec36, _dec37], Object.getOwnPropertyDescriptor(_class2.prototype, "interceptPattern"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onValidatorChange", [_dec38, _dec39], Object.getOwnPropertyDescriptor(_class2.prototype, "onValidatorChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onPatternChange", [_dec40, _dec41], Object.getOwnPropertyDescriptor(_class2.prototype, "onPatternChange"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "interceptType", [_dec42, _dec43], Object.getOwnPropertyDescriptor(_class2.prototype, "interceptType"), _class2.prototype)), _class2)) || _class);
